import { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setCurrencyRate } from 'state/balances/actions'
import { getCoingeckoSimplePrice } from './setGetProfileUser'

export const useRateCurrency = () => {
  const dispatch = useDispatch()

  const getFormatCurrency = useCallback(() => {
    getCoingeckoSimplePrice(
      {
        ids: 'binance-usd,binancecoin',
        vs_currencies: 'usd',
      },
      (data) => {
        dispatch(setCurrencyRate(data))
      },
    )
  }, [dispatch])

  useEffect(() => {
    getFormatCurrency()
  }, [getFormatCurrency])

  return [getFormatCurrency]
}
